<template lang="pug">
  .home-why-mr.container
    .row.why-title
      h2.core-title.title.text-color-2.f-secondary.xs-f-grande.sm-f-xgrande.max-at-tweak.text-center(v-html="title")
      
    .row.md-f-xmedium.lg-f-xlarge.max-at-tweak.value-wrap.xs-hide.sm-hide
      toggle.xs-12
        template(v-slot:default="{ val, toggleVal }")
          .row.text-center
            .centered-wrap
              template(v-for="(item, index) in items")
                .data-wrap(v-if="(item.link && item.link.text && item.linkHasPriorityOverCharacteristics) || !item.characteristics.length" :key="index" tabindex="0")
                  .title-wrap
                    .value-img(v-if="item.image")
                      responsive-image(:media-obj='item.image' xs-aspect-key="1x1" draggable="false" @dragstart.native.prevent="")
                    
                  .value-title.clear.thin.md-f-small.lg-f-small
                    p {{item.title}}

                  a.hard-link.btn-reset(v-if="item.link && item.link.text" @click.prevent="onLinkClick(item, val)" :href="item.link.url")
                    p.underline.upper.bold.cta-color-2.md-f-xxsmall.lg-f-xxsmall(tabindex="0") {{item.link.text}}
                      span.icon-caret-right.caret.md-f-xxxsmall.lg-f-xxxsmall.h-animated      
                
                .data-wrap(v-else :class="{'selected-tab': val == index}" :key="index" @click.prevent="toggleVal(index);" tabindex="0")
                  .title-wrap
                    .value-img(v-if="item.image")
                      responsive-image(:media-obj='item.image' xs-aspect-key="1x1" draggable="false" @dragstart.native.prevent="")

                    .value-title.clear.thin.md-f-small.lg-f-small
                      p {{item.title}}
                    
                    .value-list.md-f-xsmall.lg-f-xsmall.max-at-tweak(:id="'charsWide' + index" :aria-hidden="val != index" :aria-expanded="val == index ? 'true' : 'false'")
                      ul.the-list
                        li(v-for="(characteristic, index) in item.characteristics" :key="index")
                          span(v-html="characteristic")
                          
                    button.btn-reset(role="button" :aria-describedby="'charsWide' + index")
                      p.underline.upper.bold.cta-color-2.md-f-xxsmall.lg-f-xxsmall {{val == index ? 'See Less' : 'See More'}}
                        span.thin.big-caret.md-f-xxxsmall.lg-f-xxxsmall.icon-caret-down(:class="{'animate-caret-down': val !== index, 'animate-caret-up': val === index}")

    .xs-12.xs-f-xmedium.max-at-tweak.value-wrap.md-hide.lg-hide
        toggle.xs-12
          template(v-slot:default="{ val, toggleVal }")
            .row
              .centered-wrap
                template(v-for="(item, index) in items")
                  .data-wrap(v-if="(item.link && item.link.text && item.linkHasPriorityOverCharacteristics) || !item.characteristics.length" :key="index" tabindex="0")
                    .title-wrap.btn-reset
                      .value-img(v-if="item.image")
                        responsive-image(:media-obj='item.image' xs-aspect-key="1x1" draggable="false" @dragstart.native.prevent="")
                        
                      .description-wrap
                        .value-title.xs-f-medium.sm-f-medium
                          p {{item.title}}

                        a.hard-link.btn-reset(v-if="item.link && item.link.text" @click.prevent="onLinkClick(item, val)" :href="item.link.url")
                          p.underline.upper.bold.cta-color-2.xs-f-small.sm-f-small(tabindex="0") {{item.link.text}}
                            span.icon-caret-right.big-caret.h-animated

                  .data-wrap(v-else :class="{'selected-tab': val == index}" :key="index" tabindex="0" aria-describedby="charsSmall")
                    .title-wrap.btn-reset(data-action='disclosure')
                      .value-img(v-if="item.image")
                        responsive-image(:media-obj='item.image' xs-aspect-key="1x1" draggable="false" @dragstart.native.prevent="")
                        
                      .description-wrap
                        .value-title.xs-f-medium.sm-f-medium
                          p {{item.title}}
                          
                        button.btn-reset(@click="toggleVal(index);" role="button" :aria-describedby="'charsSmall' + index")
                          p.underline.upper.bold.cta-color-2.xs-f-small.sm-f-small
                            span {{val == index ? 'See Less' : 'See More'}}
                            span.big-caret.icon-caret-down(:class="{'animate-caret-down': val != index, 'animate-caret-up': val == index}")
                    
                    .value-list.xs-f-xxsmall.sm-f-xsmall.max-at-tweak(:id="'charsSmall' + index" :aria-hidden="val != index" :aria-expanded="val == index ? 'true' : 'false'")
                      ul.the-list
                        li(v-for="(characteristic, index) in item.characteristics" :key="index")
                          span(v-html="characteristic")
</template>

<script>
  import ResponsiveImage from '@components/ResponsiveImage';

  export default {
    name: "WhyMR",

    components: {
      ResponsiveImage,
    },

    props: {
      items: {
        type: Array,
        required: true,
      },
      title: {
        type: String,
        required: true,
      }
    },

    methods: {
      onLinkClick(item, value) {
        this.trackMREventAndRedirect(item.clickEventName, item.link.url, {tab: value});
      }
    }
  };
</script>
<style lang="stylus" scoped>
  .home-why-mr
    min-height 300px
    overflow hidden
    max-width 1300px
    margin 4em auto
        
    > div
      max-width 1400px
            
    .animate-caret-down:before
      transform rotate(0deg)
      transition transform 400ms ease
      
    .animate-caret-up:before
      transform rotate(-180deg)
      transition transform 400ms ease

    .h-animated:active::before
      animation horizontal-bounce 0.4s
      animation-direction alternate
      animation-timing-function cubic-bezier(.7, .2, 1, .7)
      animation-iteration-count infinite

    .centered-wrap
      width 670px
      display inline-flex

      .btn-reset
        margin-top 8px
      
      .hard-link
        display block
      
      .data-wrap
        position relative
        width 220px
        margin 0 auto
        margin-left 10px
        margin-right 10px
        padding 0.75em 0
          
        .title-wrap
          position relative
        
          .hard-link p
            margin-top 11px
        
        .value-list
          padding 0 1.5em

        .value-img
        .value-title
          display inline-block
          vertical-align top

        .value-title
          margin-bottom 8px
          line-height normal
            
          .caret
            line-height normal
            font-size 11px
            font-weight 900
    
        .value-img
          width 100%
          height 80px
          margin-bottom 23px
          
          .responsive-image
            height 100%
            width 80px
            display block
            margin 0px auto

            >>> img
              max-width 100%
              height auto
          
        .value-list
          overflow hidden
          max-height 0
          color text-color-2
          padding 0 5px
          transition max-height 400ms ease-in-out
          
          .the-list
            list-style-type none
            padding 0.5em 0
            
            li
              padding-bottom 0.85em

        &.selected-tab
          .value-list
            max-height 100%

  @media mq-tablet-less
    .home-why-mr
      .why-title
        margin-bottom 0.6em
        padding-left 5em

          .title
            text-align unset

        @media mq-mobile
          padding-left 1.5em

          .title
            text-align unset

      .value-wrap
        padding-left 0

      .centered-wrap
        display block
        width unset
        margin 0px 3em
        
        @media mq-mobile
          margin 0px 0.5em
          width 100%
      
        .data-wrap
          max-width 100%
          width unset
          padding 10px 0
          min-height 100px
          
          .title-wrap
            text-align left
            
            .value-img
              float left
              width 80px
              height 80px
              margin-bottom unset

              .responsive-image
                height 100%
                display block
                margin 0px auto

                >>> img
                  max-width 100%
                  height auto

            .description-wrap
              padding 0px 10px
              padding-top 10px
              margin-left 90px
        
              .value-title
                display block
                text-align left
                margin-bottom unset

          .hard-link p
            font-size 10px

          button p
            font-size 10px

    @media mq-desktop-plus
      .img-wrap
        max-width 28em
        
  @keyframes horizontal-bounce {
    from {
        transform: translateX(0);
    }
    to {
        transform: translateX(20px);
    }
  }
</style>
